import { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { limpiarPendientes } from '../../../../actions/inventarioCarga';

const VaciarPendientesModal = ({ show, onHide, onSuccess }) => {
    const dispatch = useDispatch();

    const onVaciar = () => {
        dispatch(limpiarPendientes());

        if (typeof onSuccess === 'function') {
            onSuccess();
        } else if (typeof onHide === 'function') {
            onHide();
        }
    };

    return (
        <Fragment>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Vaciar lista de pendientes</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="alert alert-warning mb-0">
                        ¿Seguro que deseas quitar todos los productos pendientes de la lista?
                        <br />
                        Ninguno de estos cambios se ha guardado en el sistema y se perderán.
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={onHide}>
                        Cancelar
                    </button>

                    <button type="button" className="btn btn-danger" onClick={onVaciar}>
                        Vaciar lista
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default VaciarPendientesModal;
